import { Header } from "@/components/layout/header";
import { Footer } from "@/components/layout/footer";
import { SaunaSeoContent } from "@/components/sauna-seo-content";
import { SaunaGallery } from "@/components/sauna-gallery";
import { CallbackForm } from "@/components/home/callback-form";
import { useSaunaSeo } from "@/hooks/use-sauna-seo";
import { findSaunaPage, SAUNA_MAIN } from "@/data/sauna-seo";
import NotFound from "@/pages/not-found";
import { SaunaLocationLinks, SaunaLocalServices } from "@/components/sauna-location-links";
import { saunaLocationServices } from "@/data/sauna-locations";
import { CaseStudyPreview } from "@/components/case-study-preview";
import "@/components/home/home.css";

export default function SaunaSeoPage({ path }: { path: string }) {
  const page = findSaunaPage(path);
  if (!page) return <NotFound />;
  return <SaunaSeoView page={page} />;
}

function SaunaSeoView({ page }: { page: NonNullable<ReturnType<typeof findSaunaPage>> }) {
  useSaunaSeo(page);
  return (
    <div className="vx-home flex flex-col min-h-[100dvh] bg-background overflow-x-clip">
      <Header />
      <main className="flex-1">
        <SaunaSeoContent page={page} basePath={import.meta.env.BASE_URL} />
        {page.locationKey && <SaunaLocalServices locationKey={page.locationKey} serviceSlug={page.serviceSlug} basePath={import.meta.env.BASE_URL} />}
        {page.path === SAUNA_MAIN && <><SaunaGallery slug="install" designs /><SaunaGallery slug="install" outdoorInfrared /><SaunaGallery slug="install" /><CaseStudyPreview slugs={["kings-gym-crawley-sauna"]} title="Sauna installation at Kings Gym Crawley" /></>}
        <section className="py-10 lg:py-14 bg-secondary/50" aria-labelledby="sauna-enquiry">
          <div className="container mx-auto px-4 max-w-6xl grid md:grid-cols-2 gap-10 items-center">
            <div>
              <h2 id="sauna-enquiry" className="font-display font-bold text-3xl mb-3">Prefer a call back?</h2>
              <p className="text-muted-foreground leading-relaxed">Leave your number and postcode and an engineer will discuss your sauna project, or email <a className="font-semibold underline underline-offset-4" href="mailto:info@vertexclimate.co.uk">info@vertexclimate.co.uk</a>.</p>
            </div>
            <CallbackForm defaultService={`Sauna — ${saunaLocationServices.find(s => s.slug === page.serviceSlug)?.title || "Install"}`} />
          </div>
        </section>
        <SaunaLocationLinks locationKey={page.locationKey} serviceSlug={page.serviceSlug} basePath={import.meta.env.BASE_URL} />
      </main>
      <Footer />
    </div>
  );
}
